// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4c691d51","239":"575b05f5","268":"720ba45a","453":"6dc3ebd2","455":"bbd59e16","551":"a0fc0b45","638":"7e5313ae","828":"c7cbd1a3","842":"46e05657"}[chunkId] + ".chunk.js";
};